import { actionGenerator, IReduxAction } from '../../utils/actions';
import { TChangeCurrentBetSource } from '../../thunks/auction/changeCurrentBet';

export const CHECK_SERVICE_AFTER_CHANGE_BET = 'CHECKOUT_INFO :: CHECK_SERVICE_AFTER_CHANGE_BET';

export type TCheckServiceAfterChangeBetAction = IReduxAction<
  typeof CHECK_SERVICE_AFTER_CHANGE_BET,
  TChangeCurrentBetSource
>;

export const checkServiceAfterChangeBet = actionGenerator<
  typeof CHECK_SERVICE_AFTER_CHANGE_BET,
  TChangeCurrentBetSource
>(CHECK_SERVICE_AFTER_CHANGE_BET);
